import UserTypes from "./users.types";

export const AddProduct = product => ({
    type: UserTypes.ADD_PRODUCT,
    payload: product
})

export const ClearProduct = product => ({
    type: UserTypes.CLEAR_PRODUCT,
    payload: product
})
export const removeProduct = product => ({
    type: UserTypes.REMOVE_PRODUCT,
    payload: product
})
export const GetLocation = (lat,long) => ({
    type: UserTypes.GET_LOCATION,
    payload: {
        latitude : lat,
        longitude : long
    }
})